import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ background: "#fff" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Our <span>B2B Portal</span> Development Services
            </h2>
            <p>
              Our B2B portal development company excels in delivering advanced
              portal development solutions designed to meet the evolving needs
              of modern businesses.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Start with a Free Call
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Custom B2B Portal Development</h4>
                  <p>
                    We build bespoke B2B web portals from the ground up,
                    integrating complex workflows and advanced data processing
                    features. Our modular architecture ensures flexibility,
                    allowing for future expansions and seamless integration with
                    existing IT systems, including legacy software. The result
                    is a highly customized, scalable platform that adapts to
                    your business requirements.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Platform-Based B2B Portal Development</h4>
                  <p>
                    We leverage powerful platforms like Dynamics 365,
                    Salesforce, and Pimcore for tailored B2B web application
                    development. This approach combines the reliability of
                    proven technologies with custom features to align with your
                    business processes. Platform-based solutions offer quicker
                    deployment and lower long-term costs, ensuring a solid
                    foundation for business growth.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>B2B Portal Modernization</h4>
                  <p>
                    Our B2B portal modernization service targets outdated
                    systems, upgrading both the technological core and
                    user-facing interface. We optimize your portal’s
                    architecture for better performance, enhance UX/UI, and
                    introduce modern functionalities to match current business
                    demands. This ensures improved usability and higher adoption
                    rates across users.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>B2B Portal Integration</h4>
                  <p>
                    We specialize in seamless integration of B2B portals with
                    enterprise-level systems like CRM, ERP, and supply chain
                    platforms. By connecting your portal with key business
                    systems, we help streamline operations, reduce manual
                    workloads, and improve data flow across departments. Our
                    solutions ensure operational efficiency and faster
                    decision-making.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>B2B Portal Migration</h4>
                  <p>
                    Our team expertly handles portal migration, whether moving
                    to a cloud-based architecture or transitioning to
                    microservices. We ensure the safe transfer of data and
                    optimize cloud resource usage for cost-effective scaling.
                    With minimal business disruption, you get a future-proofed,
                    high-performance portal.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>B2B Portal Maintenance</h4>
                  <p>
                    We provide comprehensive maintenance services to ensure your
                    B2B portal remains secure, up-to-date, and fully functional.
                    Our team performs regular performance monitoring, bug fixes,
                    and security updates. We also offer 24/7 support to resolve
                    any technical issues promptly. This proactive approach
                    minimizes downtime and ensures seamless portal operations.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
